import React, { Fragment } from 'react';

import { Button, Card, Col, notification, Row, Space, Typography } from 'antd';

import Content from 'components/_Common/_Layout/Content';
import List from 'components/_Common/List';
import { downloadSupplierReport } from 'components/Supplier/Excel';
import FormSupplier from 'components/Supplier/Form';
import { SupplierContextProvider} from 'lib/providers/SupplierContextProvider';
import { Show } from 'lib/Show';
import { removeSupplier } from 'services/Supplier.service';

import { getColumns } from './Columns';
import { Filters } from './Filters';

export function Suppliers() {
    return (
        <SupplierContextProvider>
            {({
                isLoading,
                suppliers,
                suppliersFiltered,
                supplier,
                setSupplierId,
                isFormVisible,
                setIsFormVisible,
                fetchSuppliers,
                serviceCategories,
            }) => {
                const columns = getColumns(
                    () => setIsFormVisible(true),
                    setSupplierId,
                    async (id) => {
                        const response = await removeSupplier(id);
                        await fetchSuppliers();
                        notification.open(response);
                    },
                    serviceCategories
                );

                const closeForm = () => {
                    setIsFormVisible(false);
                    setSupplierId(null);
                };

                return (
                    <Fragment>
                        <Content>
                            <Row justify="space-between" align="middle">
                                <Typography.Title level={3}>Fornecedores</Typography.Title>
                                <Space>
                                    <Button
                                        type="default"
                                        onClick={() => downloadSupplierReport(suppliers)}
                                    >
                                        Gerar relatório
                                    </Button>
                                    <Button
                                        type="primary"
                                        onClick={() => setIsFormVisible(true)}
                                    >
                                        Cadastrar
                                    </Button>
                                </Space>
                            </Row>

                            <Row>
                                <Col span={24}>
                                    <Card>
                                        <Filters />

                                        <List
                                            columns={columns}
                                            data={suppliersFiltered}
                                            loading={isLoading}
                                        />
                                    </Card>
                                </Col>
                            </Row>
                        </Content>

                        <Show when={isFormVisible}>
                            <FormSupplier
                                key={`form-${supplier?.id ?? 'new'}`}
                                closeForm={closeForm}
                                isOpen={isFormVisible}
                                supplier={supplier ?? undefined}
                                fetchSuppliers={fetchSuppliers}
                            />
                        </Show>
                    </Fragment>
                );
            }}
        </SupplierContextProvider>
    );
}
